import React, { useState } from 'react';
import { MessageCircle, X, Mail, Phone, ChevronUp } from 'lucide-react';

export const FloatingContactButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen(!isOpen);

  const contactOptions = [
    {
      icon: Phone,
      label: 'Call Us',
      value: '(940) 466-4880',
      href: 'tel:+19404664880',
    },
    {
      icon: Mail,
      label: 'Email Us',
      value: 'help@koshatax.com',
      href: 'mailto:help@koshatax.com',
    }
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Contact Options Panel */}
      <div
        className={`absolute bottom-16 right-0 transition-all duration-300 ease-out ${
          isOpen 
            ? 'opacity-100 translate-y-0 pointer-events-auto' 
            : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 overflow-hidden min-w-[280px]">
          {/* Header */}
          <div className="px-5 py-4" style={{ backgroundColor: '#1F3A8A' }}>
            <h3 className="font-semibold text-lg" style={{ color: '#FFFFFF' }}>Contact Us</h3>
            <p className="text-sm mt-1" style={{ color: '#93C5FD' }}>(940) 466-4880</p>
          </div>

          {/* Contact Options */}
          <div className="p-4 space-y-3">
            {contactOptions.map((option, index) => (
              <a
                key={index}
                href={option.href}
                className="flex items-center gap-4 p-3 rounded-xl bg-gray-50 dark:bg-gray-800 transition-colors group"
                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1E40AF'}
                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = ''}
              >
                <div 
                  className="p-2.5 rounded-full transition-transform group-hover:scale-110"
                  style={{ backgroundColor: '#1F3A8A' }}
                >
                  <option.icon className="h-5 w-5" style={{ color: '#93C5FD' }} />
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-gray-900 dark:text-white group-hover:text-white">{option.label}</p>
                  <p className="text-sm text-gray-500 dark:text-gray-400 group-hover:text-gray-200">{option.value}</p>
                </div>
                <ChevronUp className="h-4 w-4 text-gray-400 group-hover:text-white rotate-90" />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Main Floating Button */}
      <button
        onClick={toggleOpen}
        className="h-14 w-14 rounded-full shadow-xl transition-all duration-300 ease-out flex items-center justify-center border-2 border-white"
        style={{ 
          backgroundColor: isOpen ? '#374151' : '#1F3A8A',
        }}
        onMouseEnter={(e) => {
          if (!isOpen) e.currentTarget.style.backgroundColor = '#1E40AF';
          e.currentTarget.style.transform = 'scale(1.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = isOpen ? '#374151' : '#1F3A8A';
          e.currentTarget.style.transform = 'scale(1)';
        }}
      >
        {isOpen ? (
          <X className="h-6 w-6" style={{ color: '#FFFFFF' }} />
        ) : (
          <MessageCircle className="h-6 w-6" style={{ color: '#93C5FD' }} />
        )}
      </button>

      {/* Pulse Animation (when closed) */}
      {!isOpen && (
        <span 
          className="absolute inset-0 rounded-full animate-ping opacity-30 pointer-events-none" 
          style={{ backgroundColor: '#1F3A8A' }}
        />
      )}
    </div>
  );
};

export default FloatingContactButton;
